
export class BaseBean {
	public  estado: number;
	public  usuReg:number;
	public  usuMod:number;
	public fecReg:Date ;
	public  fecMod:Date;
	public hostReg:String ;
	public hostMod:String;
	public usuNomReg:String ;
	public usuNomMod:String ;
	public eliminado:Boolean ;
  }
